const Login = () => import('../views/Auth/Login');

export default {
    path      : '/login/',
    name      : 'AuthLayout',
    component : Login
};
